import { styled } from '@mui/material';

import { Chip } from '~/core/components/shared/Chip';

export const MMCChip = styled(Chip)({
  marginLeft: 4,
});
